import React, {useState} from 'react';
import Footer from '../../components/footer/Footer';
import Header from "../../components/header/Header";
import {StickyFooter} from "../../components/stickyFooter/StickyFooter";

export const CommonLayout = (props) => {
    return (
        <div className="common-layout-main ">
            <Header data={props} cartCountIncrement={props.cartCountIncrement}/>

            <main id="main">
                <div className="main-body-container">
                    <div className="row profile">
                        {props.children}
                    </div>
                </div>
            </main>

            <Footer/>
            <StickyFooter />


        </div>
    );
};
